import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CalendarEventsComponent } from "./calendar-events.component";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { InputAutocompleteModule } from "@shared/components/input-autocomplete/input-autocomplete.module";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { PaginationModule } from "@shared/components/pagination/pagination.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomerListModule } from "@shared/components/customer-list/customer-list.module";
import { InputSelectModule } from "@shared/components/input-select/input-select.module";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { CustomerLegalEntitySelectModule } from "@shared/components/customer-legal-entity-select/customer-legal-entity-select.module";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { CalendarModule } from "@shared/components/calendar/calendar.module";
import { ModalWrapperModule } from "@shared/components/modal-wrapper/modal-wrapper.module";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { PipesModule } from "src/app/shared/pipes/pipes.module";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { SharedModule } from "@shared/shared.module";
import { NoItemsLayoutModule } from "@shared/components/no-items-layout/no-items-layout.module";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { TooltipModule } from "@shared/components/tooltip/tooltip.module";
import { Iso3CountryToCurrencySymbolPipe } from "@modules/dashboard/pipes/iso3-country-to-currency-symbol.pipe";
import { MilestoneStatusDropdownComponent } from "src/app/standalone/milestone-status-dropdown/milestone-status-dropdown.component";
import { CdkMenuModule } from "@angular/cdk/menu";
import { GlobalDashboardModule } from "@modules/global-dashboard/global-dashboard.module";

@NgModule({
	declarations: [CalendarEventsComponent],
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		InputAutocompleteModule,
		InputWrapperModule,
		MatFormFieldModule,
		MatInputModule,
		MatMenuModule,
		FlexLayoutModule,
		PaginationModule,
		FormsModule,
		ReactiveFormsModule,
		CustomerListModule,
		InputSelectModule,
		MatCardModule,
		MatListModule,
		MatSelectModule,
		CustomerLegalEntitySelectModule,
		MatPaginatorModule,
		CalendarModule,
		ModalWrapperModule,
		MatTooltipModule,
		PipesModule,
		MatCheckboxModule,
		SharedModule,
		NoItemsLayoutModule,
		MatSlideToggleModule,
		TooltipModule,
		PipesModule,
		Iso3CountryToCurrencySymbolPipe,
		MilestoneStatusDropdownComponent,
		CdkMenuModule,
		GlobalDashboardModule
	],
	exports: [CalendarEventsComponent]
})
export class CalendarEventsModule {}
